import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Card } from '../../../../design-system';

const PasswordCard: React.FC = () => (
  <Card title="Password">
    <Box p={2} pt={0}>
      <Typography paragraph>Use the button below to change your password</Typography>
      <Button variant="outlined" size="small" component={RouterLink} to="/user/change-password">
        Change password
      </Button>
    </Box>
  </Card>
);

export default PasswordCard;
